import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
}

export default function Card({
  children,
  className = '',
  onClick,
  hover = false,
  ...props
}: CardProps) {
  // BRAND v3 "LEDGER": a card is a white cell on a bone ground bounded by a
  // hairline. The previous shadow-md + border-ink/10 double-encoded the edge,
  // and shadow-lg + scale on hover made a static panel behave like a button.
  const baseClasses = 'rounded-xs bg-paper border border-mineral';
  const hoverClasses = hover ? 'hover:border-ink/40 transition-colors duration-200 cursor-pointer' : '';
  const clickableClasses = onClick ? 'cursor-pointer' : '';
  
  const classes = `${baseClasses} ${hoverClasses} ${clickableClasses} ${className}`;

  return (
    <div
      onClick={onClick}
      className={classes}
      {...props}
    >
      {children}
    </div>
  );
} 